// import { CiSearch } from 'react-icons/ci';

import { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import useFormValidation from '../../../hooks/zodFormValidation';
import appSchema from '../../../schema/appSchema';
import { format, isValid } from 'date-fns';
import AddressBookPopup from '../../AddressBook/AddressBookPopup';
import setUiMessage from '../../../Utilities/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { handAllReferralDocs } from '../../../redux/slices/referralSlice';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import ReportFormPopup from './ReportFormPopup';
import AttachDocumentsPopup from './AttachDocumentsPopup';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
// import PatientDocumentPopup from './PatientDocumentPopup';
// import AddEditReferralProviderPopup from './AddEditReferralProviderPopup';

function AddReferralPopup({
  isOpen,
  onClose,
  handleReload,
  refId,
  rptSentId,
  patientId,
  reportId,
}) {
  const dispatch = useDispatch();
  const { allReferralDocs } = useSelector((store) => store.referral);
  const [patientList, setPatientList] = useState([]);
  const [searchStr, setSearchStr] = useState('');
  const [isSubmit, setSubmit] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [selectedPat, setSelectedPat] = useState(null);
  const [referredByList, setReferredByList] = useState([]);
  const [addressbook, setAddressbook] = useState(false);
  const [recipiant, setRecipiant] = useState(''); // 2 for provider
  const [formData, setFormData] = useState({
    patientId: 0,
    referralDate: new Date(),
    referredBy: 0,
    urgencyLevel: 'routine',
    referredTo: 0,
    referredToType: '',
    plannedDate: null,
    reasonForReferral: '',
    referralOrder: false,
    referralOrderPdf: '',
    clinicalSummary: false,
    clinicalSummaryPdf: '',
    transitionOfCare: false,
    transitionOfCarePdf: '',
    allAttachDocs: allReferralDocs,
    appointmentScheduled: false,
    patientInformed: false,
    appointmentDate: null,
    reportId: 0,
    refId: 0,
    rptSentId: 0,
  });

  const [generateReportPopup, setGenerateReportPopup] = useState({
    open: false,
    popUpType: '',
  });

  const [attachDocPopup, setAttachDocPopup] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState({});

  const [alertPopup, setAlertPopup] = useState(false);
  const [patStatus, setPatStatus] = useState('add');
  const [patObj, setPatObj] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await post('api/patient/referral/openReferralPopup', {
        refId: refId,
        rptSentId: rptSentId,
        patientId: patientId,
        reportId: reportId,
      });

      if (response.status === 200) {
        setReferredByList(response.data?.staff || []);
        if (response.data?.referralData) {
          setFormData((prev) => ({
            ...prev,
            patientId: response.data?.patientId
              ? Number(response.data?.patientId)
              : 0,
            referralDate:
              response.data?.referralData?.added_date &&
              response.data?.referralData?.added_date !== '0000-00-00'
                ? new Date(response.data?.referralData?.added_date)
                : new Date(),
            referredBy: response.data?.referralData?.referred_by
              ? Number(response.data?.referralData?.referred_by)
              : 0,
            urgencyLevel:
              response.data?.referralData?.urgency_level || 'routine',
            referredTo: response.data?.recipiantId
              ? Number(response.data?.recipiantId)
              : 0,
            referredToType: response.data?.receiverType || '',
            plannedDate:
              response.data?.referralData?.plan_date &&
              response.data?.referralData?.plan_date !== '0000-00-00'
                ? new Date(response.data?.referralData?.plan_date) || null
                : null,
            reasonForReferral: response.data?.referralData?.reason || '',
            referralOrder: response.data?.reportSentData?.referral_order_file
              ? true
              : false,
            referralOrderPdf:
              response.data?.reportSentData?.referral_order_file || '',
            clinicalSummary: response.data?.reportSentData
              ?.clinical_summary_file
              ? true
              : false,
            clinicalSummaryPdf:
              response.data?.reportSentData?.clinical_summary_file || '',
            transitionOfCare: response.data?.reportSentData?.toc_summary_file
              ? true
              : false,
            transitionOfCarePdf:
              response.data?.reportSentData?.toc_summary_file || '',
            allAttachDocs:
              response.data?.reportSentData?.all_attach_docs &&
              response.data?.reportSentData?.all_attach_docs.length > 0
                ? JSON.parse(response.data?.reportSentData?.all_attach_docs)
                : [],
            appointmentScheduled:
              response.data?.referralData?.appointment_taken === '1'
                ? true
                : false,
            patientInformed:
              response.data?.referralData?.patient_informed === '1'
                ? true
                : false,
            appointmentDate:
              response.data?.referralData?.appointment_taken_date &&
              response.data?.referralData?.appointment_taken_date !==
                '0000-00-00'
                ? new Date(
                    response.data?.referralData?.appointment_taken_date,
                  ) || null
                : null,
            reportId: response.data?.reportId || 0,
            refId: response.data?.refId || 0,
            rptSentId: response.data?.rptSentId || 0,
          }));
          setSelectedDocs((prev) => {
            let selectedObjs = {};
            const attachDocs =
              response.data?.reportSentData?.all_attach_docs &&
              JSON.parse(response.data?.reportSentData?.all_attach_docs);
            if (attachDocs && attachDocs.length > 0) {
              attachDocs.forEach((doc) => {
                if (
                  doc?.sectionId !== 'patient_referral' &&
                  doc?.sectionId !== 'clinical_summary' &&
                  doc?.sectionId !== 'transition_of_care'
                ) {
                  selectedObjs = { ...selectedObjs, [doc.sectionId]: doc };
                }
              });
            }
            return selectedObjs;
          });
          if (
            response.data?.reportSentData?.all_attach_docs &&
            response.data?.reportSentData?.all_attach_docs.length > 0
          ) {
            dispatch(
              handAllReferralDocs(
                JSON.parse(response.data?.reportSentData?.all_attach_docs) ||
                  [],
              ),
            );
          }
          setSelectedPat({
            patName: response.data?.patientName || '',
            dob: response.data?.dob || '',
            ageWithGender: response.data?.ageWithGender || '',
            chart_number: response.data?.patientInfo?.chart_number || '',
          });
          setRecipiant(response.data?.receiverName || '');
        }
      }
    };
    fetchData();
  }, [refId, rptSentId, patientId, reportId, dispatch]);

  useEffect(() => {
    if (searchStr === '' || searchStr.length < 3) {
      setPatientList([]);
      return;
    }
    const handlePatSearch = async () => {
      const response = await post('api/patient/referral/searchPatient', {
        searchStr: searchStr,
      });

      if (response.status === 200) {
        setPatientList(response.data?.patientList || []);
      }
    };

    const debouncedFetch = debounce(handlePatSearch, 500);

    debouncedFetch(searchStr);

    // Cleanup on unmount
    return () => {
      debouncedFetch.cancel();
    };
  }, [searchStr]);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.addReferralForm(),
    formData: formData,
    isSubmit,
  });

  const handleSaveReferral = async (e, isSend) => {
    e.preventDefault();
    setSubmit(true);

    const validationError = validateForm();
    if (validationError) {
      scrollToError(validationError);
      return;
    }

    if (isSend && allReferralDocs.length === 0) {
      setUiMessage('err', 'Please select at least one document to fax.');
      return;
    }
    try {
      const response = await post('api/patient/referral/saveReferral', {
        formData: {
          ...formData,
          referralDate: format(formData.referralDate, 'yyyy-MM-dd'),
          plannedDate: formData.plannedDate
            ? format(formData.plannedDate, 'yyyy-MM-dd')
            : null,
          appointmentDate: formData.appointmentDate
            ? format(formData.appointmentDate, 'yyyy-MM-dd')
            : null,
          referringProvider: formData.referredBy,
          recipientProvider: formData.referredTo,
          recipientProviderType: formData.referredToType,
          referralOrderDoc: formData.referralOrderPdf,
          clinicalSummaryDoc: formData.clinicalSummaryPdf,
          transitionOfCareDoc: formData.transitionOfCarePdf,
          allAttachDocs: JSON.stringify(allReferralDocs),
          attachedFiles: allReferralDocs.map((el) => el.docsName).join(','),
          appointmentScheduled: formData.appointmentScheduled ? '1' : '0',
          patientInformed: formData.patientInformed ? '1' : '0',
        },
        sendFax: isSend,
      });

      if (response.status === 200) {
        if (!response.data?.success) {
          setUiMessage('err', response.data?.message);
          return;
        }
        // Handle success
        handleReload();
        handleCloseReferralPopup();
      }
    } catch (err) {
      setErrMsg(err?.response.data.message);
    }
  };

  const handleUpdateReferral = async (e, isSend) => {
    e.preventDefault();
    setSubmit(true);

    const validationError = validateForm();
    if (validationError) {
      scrollToError(validationError);
      return;
    }

    if (isSend && allReferralDocs.length === 0) {
      setUiMessage('err', 'Please select at least one document to fax.');
      return;
    }
    try {
      const response = await post('api/patient/referral/updateReferral', {
        formData: {
          ...formData,
          referralDate: format(formData.referralDate, 'yyyy-MM-dd'),
          plannedDate: formData.plannedDate
            ? format(formData.plannedDate, 'yyyy-MM-dd')
            : null,
          appointmentDate: formData.appointmentDate
            ? format(formData.appointmentDate, 'yyyy-MM-dd')
            : null,
          referringProvider: formData.referredBy,
          recipientProvider: formData.referredTo,
          recipientProviderType: formData.referredToType,
          referralOrderDoc: formData.referralOrderPdf,
          clinicalSummaryDoc: formData.clinicalSummaryPdf,
          transitionOfCareDoc: formData.transitionOfCarePdf,
          allAttachDocs: JSON.stringify(allReferralDocs),
          attachedFiles: allReferralDocs.map((el) => el.docsName).join(','),
          appointmentScheduled: formData.appointmentScheduled ? '1' : '0',
          patientInformed: formData.patientInformed ? '1' : '0',
        },
        sendFax: isSend,
      });

      if (response.status === 200) {
        // Handle success
        if (!response.data?.success) {
          setUiMessage('err', response.data?.message);
          return;
        }
        setUiMessage('suc', 'Referral updated successfully');
        handleReload();
        handleCloseReferralPopup();
      }
    } catch (err) {
      setUiMessage('err', err?.response.data.message);
    }
  };

  const handleDefaultDocsReferralOrder = async (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        referralOrder: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'patient_referral',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (!formData.patientId) {
      setUiMessage('err', 'Please select patient to add referral order');
      return;
    }
    if (!formData.referredBy) {
      setUiMessage(
        'err',
        'Please select referring provider to add referral order',
      );
      return;
    }
    if (!formData.referredTo) {
      setUiMessage(
        'err',
        'Please select recipient provider to add referral order',
      );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      referralOrder: e.target.checked,
    }));

    const response = await post(
      'api/patient/referral/patientReferralOrderPdf',
      {
        patientId: formData.patientId,
        referredBy: formData.referredBy,
        referredTo: formData.referredTo,
        referredToType: formData.referredToType,
        reasonForReferral: formData.reasonForReferral,
        referralDate: format(formData.referralDate, 'yyyy-MM-dd'),
      },
    );

    if (response.status === 200) {
      setUiMessage('suc', 'Referral order added successfully');
      let dataObj = JSON.parse(response.data);
      let docObj = {
        sectionId: 'patient_referral',
        docsSection: 'referral order',
        docsTitle: 'Referral Order',
        docsId: '0',
        docsName: dataObj?.file_name,
        docsUrl: dataObj?.file_url,
        docsDate: dataObj?.date,
      };
      setFormData((prev) => ({
        ...prev,
        referralOrderPdf: dataObj?.file_name,
      }));
      dispatch(handAllReferralDocs([...allReferralDocs, docObj]));
    }
  };

  const handleDefaultDocsClinicalSummary = (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        clinicalSummary: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'clinical_summary',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (e.target.checked && !formData.patientId) {
      setUiMessage('err', 'Please select patient first');
      return;
    }
    setGenerateReportPopup({
      popUpType: 'clinical',
      open: true,
    });
  };

  const handleDefaultDocsToc = (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        transitionOfCare: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'transition_of_care',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (e.target.checked && !formData.patientId) {
      setUiMessage('err', 'Please select patient first');
      return;
    }
    setGenerateReportPopup({
      popUpType: 'toc',
      open: true,
    });
  };

  function handleRemoveDocs(index) {
    const docToRemove = allReferralDocs[index]; // store before splicing
    const updatedDocs = allReferralDocs.filter((_, i) => i !== index);

    if (docToRemove?.sectionId === 'patient_referral') {
      setFormData((prev) => ({
        ...prev,
        referralOrder: false,
      }));
    } else if (docToRemove?.sectionId === 'clinical_summary') {
      setFormData((prev) => ({
        ...prev,
        clinicalSummary: false,
      }));
    } else if (docToRemove?.sectionId === 'transition_of_care') {
      setFormData((prev) => ({
        ...prev,
        transitionOfCare: false,
      }));
    }

    dispatch(handAllReferralDocs(updatedDocs));
  }

  const handleCloseReferralPopup = () => {
    onClose();
    dispatch(handAllReferralDocs([]));
  };

  const handlePatientChangeRemove = (obj = null, selPatStatus) => {
    let selectedPatNo = 0;
    if (obj && selPatStatus === 'add') {
      selectedPatNo = Number(obj.user_id);
    }
    if (patObj && selPatStatus === 'change') {
      selectedPatNo = Number(patObj.user_id);
      setSelectedPat(patObj);
    }
    if (selPatStatus === 'remove') setSelectedPat(null);
    dispatch(handAllReferralDocs([]));
    setSelectedDocs({});
    setRecipiant('');
    setFormData((prev) => ({
      ...prev,
      patientId: selectedPatNo,
      referralDate: new Date(),
      referredBy: 0,
      urgencyLevel: 'routine',
      referredTo: 0,
      referredToType: '',
      plannedDate: null,
      reasonForReferral: '',
      referralOrder: false,
      referralOrderPdf: '',
      clinicalSummary: false,
      clinicalSummaryPdf: '',
      transitionOfCare: false,
      transitionOfCarePdf: '',
      allAttachDocs: [],
      appointmentScheduled: false,
      patientInformed: false,
      appointmentDate: null,
    }));
    setPatientList([]);
    setSearchStr('');
  };

  const scrollToError = (validationErrors) => {
    if (validationErrors && validationErrors.length > 0) {
      const firstError = validationErrors[0];
      const errorPath = firstError.path[0];

      const fieldIdMap = {
        patientId: 'patientSearch',
        referredBy: 'referredBy',
        referredTo: 'referredTo_container',
        reasonForReferral: 'reasonForReferral',
        appointmentDate: 'appointmentDate_container',
      };

      const elementId = fieldIdMap[errorPath];
      if (elementId) {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // If it's the search input, focus it
          if (
            elementId === 'patientSearch' ||
            elementId === 'reasonForReferral'
          ) {
            element.focus();
          }
        }
      }
    }
  };

  return (
    // modalBackground
    <div className="">
      <div className="popup active" id="referralPopup">
        <p className="red" aria-live="assertive">
          {errMsg}
        </p>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="popup__content p-6 overflow-hidden base">
            <div className="popup-header mb-5 border-0">
              <h2
                className="fw-600 fs-sm text-slate-700 opacity-90"
                style={{ fontSize: '17px' }}
              >
                New Referral Request
              </h2>
              <span
                className="close-btn"
                id="closeBtn"
                onClick={handleCloseReferralPopup}
              >
                &times;
              </span>
            </div>
            <div className="popup-body border-b-1 border-b-lightgray">
              <div className="tabContainer tabContainer__scrollbar">
                <div className="pt-3">
                  <h3
                    className="fw-600 text-slate-700 opacity-90 border-b-1 border-b-slate-100 pb-4"
                    style={{ fontSize: '17px' }}
                  >
                    Patient Information
                  </h3>
                </div>
                <div className="tabContainer__group flex flex-col flex-1 my-4">
                  <label className="pb-3 fs-13 text-slate-600">
                    Patient Search <span className="text-danger">*</span>
                  </label>

                  <div
                    className={`tabContainer__input-wrapper flex items-center border rounded-md px-2 ${
                      errors?.patientId && errors?.patientId?.message
                        ? 'border-danger'
                        : 'border-lightgray'
                    } bg-white h-10`}
                  >
                    <img
                      src="./images/search.svg"
                      width="16"
                      className="opacity-50"
                      alt=""
                    />
                    <input
                      type="search"
                      className="text-slate-600 tabContainer__input flex-1 fs-13 form-control shadow-sm"
                      id="patientSearch"
                      placeholder="Search by patient name or chart number..."
                      onChange={(e) => setSearchStr(e.target.value)}
                      value={searchStr}
                    />
                  </div>

                  <div id="patientList" className="mt-1">
                    {patientList.length > 0 ? (
                      <div className="search-results-dropdown shadow-sm border border-lightgray rounded-md bg-white overflow-hidden max-h-60 overflow-y-auto">
                        {patientList.map((obj, idx) => (
                          <div
                            className="usr-name p-2 hover:bg-light cursor-pointer border-b last:border-b-0 fs-xs"
                            onClick={() => {
                              if (selectedPat) {
                                setPatStatus('change');
                                setPatObj(obj);
                                setAlertPopup(true);
                              } else {
                                setPatStatus('add');
                                setSelectedPat(obj);
                                handlePatientChangeRemove(obj, 'add');
                              }
                            }}
                            key={obj.user_id}
                          >
                            <span className="font-semibold">{obj.patName}</span>
                            <span className="mx-2 opacity-30">|</span>
                            <span>DOB: {obj.dob}</span>
                            <span className="mx-2 opacity-30">|</span>
                            <span>{obj.ageWithGender}</span>
                            <span className="mx-2 opacity-30">|</span>
                            <span>ID: {obj.chart_number}</span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {isSubmit &&
                          errors?.patientId &&
                          errors?.patientId?.message && (
                            <p className="error-msg">
                              Please select patient from the list
                            </p>
                          )}
                      </>
                    )}
                  </div>
                </div>

                {/* show data after search */}
                <div className="tabContainer__list mb-3">
                  {formData?.patientId !== 0 && (
                    <div className="tabContainer__item mb-3 p-2 border border-primary bg-light-primary fs-xs rounded-md flex justify-between items-center">
                      <div className="tabContainer__info">
                        <span className="font-semibold text-primary">
                          {`${selectedPat?.patName} | ${selectedPat?.dob} | ${selectedPat?.chart_number}`}
                        </span>
                      </div>
                      <span
                        className="text-danger cursor-pointer font-bold px-2 fs-lg"
                        onClick={() => {
                          if (selectedPat) {
                            setPatStatus('remove');
                            setPatObj(null);
                            setAlertPopup(true);
                          }
                        }}
                      >
                        ×
                      </span>
                    </div>
                  )}
                </div>
                <div className="tabContainer__group flex flex-col flex-1 mb-5">
                  <label className="pb-2 fs-13 text-slate-600">
                    Referral Date <span className="text-danger">*</span>
                  </label>
                  <div className="tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referralDate cursor-pointer referral-date-picker">
                    <img
                      src="./images/calender.svg"
                      width={18}
                      className="ml-2 opacity-50 referralImg"
                      alt="Calendar"
                    />

                    <DatePickerCalander
                      selectedDate={formData.referralDate}
                      setSelectedDate={(date) => {
                        if (!isValid(date)) return;
                        setFormData((prev) => ({
                          ...prev,
                          referralDate: date,
                        }));
                      }}
                      onBlur={() => {
                        if (
                          !formData.referralDate ||
                          !isValid(formData.referralDate) ||
                          format(formData.referralDate, 'yyyy') === '2000'
                        ) {
                          setFormData((prev) => ({
                            ...prev,
                            referralDate: new Date(),
                          }));
                        }
                      }}
                      className="width100 tabContainer__input flex-1 fs-13 form-control text-slate-600"
                      dateFormat={DEFAULT_DATE_FORMATE}
                      editFlag={false}
                      containerDivStyle={{ width: '100%' }}
                      todayButton="Today"
                      style={{ width: '100%' }}
                    />
                    {/* <img
                      src="./images/calender.svg"
                      width={16}
                      className="opacity-50 ml-2"
                      alt="Calendar"
                    /> */}
                  </div>
                </div>

                <div className="mb-4">
                  <h3 className="fw-600 border-b-1 border-b-lightgray fs-sm pb-2 mb-3">
                    Referral Details
                  </h3>

                  <div className="tabContainer__row flex gap-4 flex-wrap mb-0 grid grid-cols-2">
                    <div className="tabContainer__group flex flex-col flex-1">
                      <label className="pb-2 fs-13 text-slate-600">
                        Referring Provider{' '}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control text-slate-600 fs-13 ${
                          errors?.referredBy && errors?.referredBy?.message
                            ? 'border-danger'
                            : ''
                        }`}
                        id="referredBy"
                        value={Number(formData.referredBy)}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            referredBy: Number(e.target.value),
                          }));
                        }}
                      >
                        <option value={0}>Select referring provider</option>
                        {referredByList.length > 0 &&
                          referredByList.map((obj) => (
                            <option key={obj.id} value={Number(obj.id)}>
                              {obj.name}
                            </option>
                          ))}
                      </select>
                      {errors?.referredBy && errors?.referredBy?.message && (
                        <p className="error-msg mt-1">
                          {errors.referredBy.message}
                        </p>
                      )}
                    </div>

                    <div className="tabContainer__group flex flex-col flex-1">
                      <label className="pb-2 fs-13 text-slate-600">
                        Urgency Level<span className="text-danger">*</span>
                      </label>
                      <select
                        style={{ background: 'white' }}
                        className="form-control text-slate-600 fs-13"
                        value={formData.urgencyLevel || 'routine'}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            urgencyLevel: e.target.value,
                          }));
                        }}
                      >
                        <option value="routine">Routine</option>
                        <option value="urgent">Urgent</option>
                        <option value="asap">ASAP</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="pt-4">
                  <h3
                    className="fw-600 text-slate-700 opacity-90 border-b-1 border-b-slate-100 pb-4"
                    style={{ fontSize: '17px' }}
                  >
                    Referral Details
                  </h3>
                </div>
                <div className="tabContainer__row flex gap-4 flex-wrap my-4">
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="pb-2 fs-13 text-slate-600">
                      Recipient Provider/Clinic
                      <span className="text-danger">*</span>
                    </label>
                    <div>
                      <label className="referralDate bg-white tabContainer__item flex items-center gap-2 py-2-5 px-2 border border-lightgray fs-13 rounded-md cursor-pointer">
                        <div
                          id="referredTo_container"
                          className={`tabContainer__info flex items-center gap-2 ${
                            errors?.referredTo && errors?.referredTo?.message
                              ? 'border-danger'
                              : 'border-lightgray'
                          }`}
                          onClick={() => setAddressbook(true)}
                        >
                          <img
                            src="./images/padnote-black.svg"
                            width={16}
                            className="opacity-50 referralImg"
                            alt="Recipient"
                          />

                          <span className="fs-13 text-slate-600 truncate">
                            {recipiant || 'Select Recipient'}
                          </span>
                        </div>
                      </label>
                    </div>
                    <div className="text-danger my-3">
                      {errors?.referredTo && errors?.referredTo?.message && (
                        <p className="error-msg mt-1">
                          {' '}
                          {errors.referredTo.message}{' '}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="tabContainer__group flex flex-col flex-1">
                    <label className="pb-2 fs-13 text-slate-600">
                      Planned Date
                    </label>
                    <div className="referralDate tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referral-date-picker">
                      <img
                        src="./images/calender.svg"
                        width={18}
                        className="ml-2 opacity-50 referralImg"
                        alt="Calendar"
                      />
                      <DatePickerCalander
                        selectedDate={formData.plannedDate || null}
                        setSelectedDate={(date) => {
                          if (date && !isValid(date)) return;
                          setFormData((prev) => ({
                            ...prev,
                            plannedDate: date || null,
                          }));
                        }}
                        className="tabContainer__input flex-1 fs-xs form-control fs-13 w-100"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        editFlag={false}
                        containerDivStyle={{ width: '100%' }}
                        todayButton="Today"
                      />
                    </div>
                  </div>
                </div>

                <div className="tabContainer__group flex flex-col flex-1 mb-3">
                  <label className="pb-2 fs-13 text-slate-600">
                    Reason for Referral<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="reasonForReferral"
                    className={`form-control ${
                      errors?.reasonForReferral &&
                      errors?.reasonForReferral?.message
                        ? 'border-danger'
                        : ''
                    }`}
                    rows={4}
                    placeholder="Enter reason for referral..."
                    value={formData.reasonForReferral}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        reasonForReferral: e.target.value,
                      }))
                    }
                  />
                  <div className="red my-3">
                    {errors?.reasonForReferral &&
                      errors?.reasonForReferral?.message && (
                        <p className="error-msg mt-1">
                          {errors.reasonForReferral.message}
                        </p>
                      )}
                  </div>
                </div>
                {/* Documents */}
                <div className="py-4">
                  <h3
                    className="fw-600 text-slate-700 opacity-90 border-b-1 border-b-slate-100 pb-4"
                    style={{ fontSize: '17px' }}
                  >
                    Documents
                  </h3>
                  <div
                    className="fw-500 text-slate-600 pt-6"
                    style={{ fontSize: '15px' }}
                  >
                    Default Documents
                  </div>
                </div>

                <div className="tabContainer__row flex gap-4 flex-wrap mb-3">
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 px-2 py-2-5 bg-light border border-slate-100 rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        className="checkBoxColor"
                        checked={formData.referralOrder}
                        onChange={handleDefaultDocsReferralOrder}
                        name="referralOrder"
                      />
                      <div className="tabContainer__info">
                        <span className="fs-13 text-slate-600">
                          Referral Order
                        </span>
                      </div>
                    </label>
                  </div>
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 px-2 py-2-5 bg-light border border-slate-100 rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        checked={
                          formData.clinicalSummary &&
                          formData.clinicalSummaryPdf
                        }
                        value={formData.clinicalSummary}
                        onChange={handleDefaultDocsClinicalSummary}
                        name="clinicalSummary"
                        disabled={formData.transitionOfCare ? true : false}
                        className="checkBoxColor"
                      />
                      <div className="tabContainer__info">
                        <span className="fs-13 text-slate-600">
                          Clinical Summary
                        </span>
                      </div>
                    </label>
                  </div>
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 px-2 py-2-5 bg-light border border-slate-100 rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        className="checkBoxColor"
                        checked={
                          formData.transitionOfCare &&
                          formData.transitionOfCarePdf
                        }
                        value={formData.transitionOfCare}
                        onChange={handleDefaultDocsToc}
                        name="transitionOfCare"
                        disabled={formData.clinicalSummary ? true : false}
                      />
                      <div className="tabContainer__info">
                        <span className="fs-13 text-slate-600">
                          Transition of Care
                        </span>
                      </div>
                    </label>
                  </div>
                </div>

                <div className="tabContainer__row flex justify-between items-center pt-2 mb-3">
                  <p
                    className="fw-500 text-slate-600"
                    style={{ fontSize: '15px' }}
                  >
                    Patient Chart Documents
                  </p>
                  <button
                    className="border-0 fs-13 referralDate bg-transparent text-slate-600 py-2 px-3 rounded-md flex items-center gap-2 cursor-pointer"
                    onClick={() => {
                      if (formData.patientId) setAttachDocPopup(true);
                      else setUiMessage('err', 'Please select patient first');
                    }}
                  >
                    <img
                      src="./images/upload.svg"
                      width={15}
                      className="opacity-70 referralImg"
                      alt=""
                    />
                    <span className="referralColor">
                      Select from patient chart
                    </span>
                  </button>
                </div>
                {allReferralDocs.length === 0 ? (
                  <div className="tabContainer__group flex flex-col gap-4 items-center mb-3 py-8 border-2 border-dashed border-slate-100 rounded-md">
                    <img src="./images/file-alt.svg" width={55} alt="" />
                    <span
                      className="text-slate-500"
                      style={{ fontSize: '17px' }}
                    >
                      No documents from patient chart
                    </span>
                    <p className="fs-xxs text-slate-500 opacity-90">
                      Click "Select from Patient Chart" to attach documents
                    </p>
                  </div>
                ) : (
                  <div className="tabContainer__group flex flex-col gap-4 mb-3 p-5 border-2 border-dashed border-slate-100 rounded-sm">
                    <div className="tabContainer__list flex flex-col gap-3">
                      {allReferralDocs.map((obj, idx) => (
                        <div
                          key={obj.sectionId}
                          className="tabContainer__item flex items-center gap-2 p-2 border border-lightgray fs-xs rounded-md cursor-pointer"
                          id={`attchedLevel_${obj.sectionId}`}
                        >
                          <div className="tabContainer__icon lightblue flex items-center justify-center rounded-md">
                            <img
                              src="./images/user-blue.svg"
                              width={15}
                              alt=""
                            />
                          </div>
                          <div className="tabContainer__info flex flex-col">
                            <span className="">
                              <Link to={obj.docsUrl} target="_blank">
                                {obj.docsTitle}
                              </Link>
                            </span>
                            <span className="fs-xxs text-gray">
                              {obj.docsDate}
                            </span>
                          </div>
                          <img
                            src="./images/delete.svg"
                            className="ml-auto"
                            width={15}
                            alt="Delete"
                            onClick={() => handleRemoveDocs(idx)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Status & Follow-up */}
                <div className="mb-4">
                  <h3 className="fw-500 border-b-1 border-b-lightgray fs-sm py-3 mb-3">
                    Status &amp; Follow-up
                  </h3>
                </div>
                <div className="tabContainer__row flex items-center gap-5 flex-wrap mb-3">
                  <div className="flex flex-col gap-3 flex-1">
                    <div className="tabContainer__list">
                      <label className="tabContainer__item flex items-center justify-between gap-2 p-3-5 fs-13 bg-white border border-slate-100 rounded-lg cursor-pointer">
                        <div className="tabContainer__info">
                          <span className="fs-13 text-slate-600">
                            Appointment Scheduled
                          </span>
                        </div>

                        <input
                          type="checkbox"
                          checked={formData.appointmentScheduled}
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              appointmentScheduled: !prev.appointmentScheduled,
                            }))
                          }
                          className="checkBoxColor"
                        />
                      </label>
                    </div>
                    <div className="tabContainer__list">
                      <label className="tabContainer__item flex items-center justify-between gap-2 p-3-5 fs-13 bg-white border border-slate-100 rounded-lg cursor-pointer">
                        <div className="tabContainer__info">
                          <span className="fs-13 text-slate-600">
                            Patient Informed
                          </span>
                        </div>
                        <input
                          type="checkbox"
                          checked={formData.patientInformed}
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              patientInformed: !prev.patientInformed,
                            }))
                          }
                          className="checkBoxColor"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="tabContainer__group flex flex-col flex-1 mb-3">
                    <label className="pb-2 fs-13 text-slate-600">
                      Appointment Date
                    </label>
                    <div className="referralDate tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referral-date-picker">
                      <img
                        src="./images/calender.svg"
                        width={18}
                        className="ml-2 opacity-50 referralImg"
                        alt=""
                      />
                      {/* <input
                        type="date"
                        className="tabContainer__input flex-1 fs-xs form-control"
                        placeholder="Select date"
                        value={
                          formData.appointmentDate
                            ? format(formData.appointmentDate, 'yyyy-MM-dd')
                            : ''
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            appointmentDate: e.target.value
                              ? new Date(e.target.value)
                              : null,
                          }))
                        }
                      /> */}
                      <DatePickerCalander
                        selectedDate={formData.appointmentDate || null}
                        setSelectedDate={(date) => {
                          if (date && !isValid(date)) return;
                          setFormData((prev) => ({
                            ...prev,
                            appointmentDate: date || null,
                          }));
                        }}
                        className="tabContainer__input flex-1 fs-xs form-control fs-13 w-100"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        editFlag={false}
                        containerDivStyle={{ width: '100%' }}
                        todayButton="Today"
                      />
                    </div>
                    {errors?.appointmentDate && (
                      <p className="error-msg mt-1">
                        {errors.appointmentDate.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-footer flex items-center gap-4 pt-4">
              <button
                type="button"
                className="btn-outline-gray-100 text-slate-600 rounded-md py-2-5"
                onClick={handleCloseReferralPopup}
              >
                Cancel
              </button>
              {refId ? (
                <>
                  <button
                    type="button"
                    className="btn-outline-gray-100 text-slate-600 rounded-md py-2-5"
                    onClick={(e) => handleUpdateReferral(e, false)}
                  >
                    Update Referral
                  </button>
                  <button
                    type="button"
                    className="btn-primary rounded-md py-2-5"
                    onClick={(e) => handleUpdateReferral(e, true)}
                  >
                    Update &amp; Fax Referral
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn-outline-gray-100 text-slate-600 fs-13 py-2-5 rounded-md flex-1"
                    onClick={(e) => handleSaveReferral(e, false)}
                  >
                    Save Referral
                  </button>
                  <button
                    type="button"
                    className="btn-primary rounded-md flex-1 fs-13 py-2-5"
                    onClick={(e) => handleSaveReferral(e, true)}
                  >
                    Save &amp; Fax Referral
                  </button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
      {addressbook && (
        <AddressBookPopup
          onClose={() => setAddressbook(false)}
          type={2}
          onSelectAddress={(address, type) => {
            if (!address.fax) {
              setUiMessage('err', 'Fax number is not available');
              return;
            }

            let displayName = address.nameLabel;

            // Handle cases where nameLabel might be empty or just a placeholder like ", "
            const hasValidName =
              displayName && displayName !== ', ' && displayName.trim() !== '';

            if (type === 2) {
              if (hasValidName && address.clinic_name) {
                displayName = `${displayName} (${address.clinic_name})`;
              } else if (!hasValidName) {
                displayName = address.clinic_name;
              }
            } else if (type === 3 || type === 5) {
              displayName = address.facility_name;
            } else if (type === 4) {
              displayName = address.insurance_company_name;
            }

            setRecipiant(displayName || address.nameLabel);
            setFormData((prev) => ({
              ...prev,
              referredTo: Number(address.id),
              referredToType: type,
            }));
            setAddressbook(false);
          }}
          selectAny={true}
        />
      )}

      {formData?.patientId && generateReportPopup.open && (
        <ReportFormPopup
          onClose={() =>
            setGenerateReportPopup({ ...generateReportPopup, open: false })
          }
          patId={formData?.patientId}
          selectedPat={selectedPat}
          popUpType={generateReportPopup.popUpType}
          selectPurposeOption={(opt) =>
            setGenerateReportPopup({ ...generateReportPopup, popUpType: opt })
          }
          setFormData={setFormData}
        />
      )}
      {formData?.patientId && attachDocPopup && (
        <AttachDocumentsPopup
          patientId={formData?.patientId}
          selectedDocs={selectedDocs}
          setSelectedDocs={setSelectedDocs}
          closePopup={() => setAttachDocPopup(false)}
        />
      )}
      {alertPopup && (
        <ConfirmDialog
          title={`Confirmation`}
          bodytext={`Are you sure you want to remove/change this patient? All details added will be removed.`}
          closeDialog={() => {
            setPatObj(null);
            setAlertPopup(false);
          }}
          successDialog={() => handlePatientChangeRemove(null, patStatus)}
        />
      )}
    </div>
  );
}

export default AddReferralPopup;
